export class CareOrderBabyFormForCachePutDConverter {
    #careOrderBabyForm;
    constructor({ careOrderBabyForm }) {
        this.#careOrderBabyForm = careOrderBabyForm;
    }
    get data() {
        const { gender, height, weight, age, hospitalObj, hospitalBed, symptom, servedItem, tube, lang, notes, requiredGender, contactName, contactGender, contactPhone, contactEmail, } = this.#careOrderBabyForm;
        return {
            'patient.gender': gender,
            'patient.height': height,
            'patient.weight': weight,
            'patient.age': age,
            hospital: hospitalObj,
            hospitalBed,
            symptom: symptom || [],
            servedItem: servedItem || [],
            tube: tube || [],
            lang,
            notes,
            requiredGender,
            'contact.name': contactName,
            'contact.gender': contactGender,
            'contact.phone': contactPhone,
            'contact.email': contactEmail,
        };
    }
}
